<template>
  <div id="app">
    <!-- add unique routerKey to update component if clicked on link that leads to current page -->
    <router-view :key="routerKey" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'App',
  computed: {
    ...mapState({
      routerKey: state => state.uniqueKey.key,
    }),
  },
  mounted() {
    this.getAuthFromStorage();
  },
  methods: {
    ...mapActions(['getAuthFromStorage']),
  },
};
</script>

<style src="./../src/assets/scss/main.scss" lang="scss">
</style>



// WEBPACK FOOTER //
// src/App.vue